import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import { AuthContext } from "../context/AuthProvider"; // Ensure path is correct
import LoginSchema from "./LoginSchema"; // Ensure path is correct and schema exists
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { FiLogIn, FiUser, FiLock, FiEye, FiEyeOff } from "react-icons/fi"; // Icons
import { FcGoogle } from "react-icons/fc";
import "./Login.css";
import { FaFacebook } from "react-icons/fa6";
const Login = () => {
  const { login, user, googleLogin,facebookLogin } = useContext(AuthContext);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api/";
  const gradientColor = "linear-gradient(135deg, #e5272e 0%, #f59332 100%)";
  const primaryAccentColor = "#e5272e";
  const navigate = useNavigate()

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get("code");
   console.log(code)
    if (code) {
      fetch(`${baseUrl}auth/google/callback?code=${code}`, {code})
        .then((res) => res.json())
        .then((data) => {
          console.log("User Info:", data.user);
          // Store token or login logic here
          if (data.token) {
            localStorage.setItem("token", data.token);
          } // Example
          navigate('/')
          
          window.location.reload()
        })
        .catch((err) => console.error("Auth Error", err));
    }
  }, [location.search, baseUrl]);

  const {
    values: loginValues,
    handleBlur: loginHandleBlur,
    handleChange: loginHandleChange,
    handleSubmit: loginHandleSubmit,
    errors: loginErrors,
    touched: loginTouched,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: LoginSchema,
    onSubmit: async (values, action) => {
      setLoading(true);
      const res = await login(values);
      setLoading(false);

      if (res.success) {
        toast.success("Login successful!");
        action.resetForm();
        // Navigation will be handled by the `if (user)` block
      } else {
        toast.error(
          res.message || "Login failed. Please check your credentials."
        );
      }
    },
  });

  const handleGoogleLogin = async () => {
    setLoading(true);
    const res = await googleLogin();
    setLoading(false);
    if (res?.success) {
      toast.success("Google login successful!");
    } else {
      
    }
  };
  const handleFacebookLogin = async () => {
    setLoading(true);
    const res = await facebookLogin();
    setLoading(false);
    if (res?.success) {
      toast.success("Facebook login successful!");
    } else {
     
    }
  }
  // Redirect if user is already logged in

  if (user) {
    const from =
      location.state?.from?.pathname || location?.state?.pathName || "/";
    return <Navigate to={from} replace />;
  }

  return (
    <>
      <style>
        {`
          .login-page-container {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f4f7f9; /* Light gray background */
            padding: 2rem 0;
          }
          .login-card {
            background-color: #ffffff;
            border-radius: 16px;
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            display: flex;
            width: 100%;
            max-width: 900px; /* Max width for the card */
          }
          .login-form-section {
            padding: 2.5rem 3rem; /* Increased padding */
            flex: 1 1 55%; /* Form takes more space */
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .login-visual-section {
            flex: 1 1 45%; /* Visual section */
            background-image: ${gradientColor};
            background-size: 200% 200%; /* For animation */
            animation: gradientAnimation 10s ease infinite;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: white;
            padding: 2rem;
            text-align: center;
          }
          @keyframes gradientAnimation {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .login-visual-section h2 {
            font-weight: 700;
            font-size: 2.5rem;
            margin-bottom: 1rem;
            text-shadow: 1px 1px 3px rgba(0,0,0,0.2);
          }
          .login-visual-section p {
            font-size: 1.1rem;
            opacity: 0.9;
            max-width: 300px;
          }
          .login-title {
            font-size: 2rem;
            font-weight: 700;
            color: ${primaryAccentColor};
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
          }
          .login-title svg {
            margin-right: 10px;
          }
          .login-subtitle {
            font-size: 1rem;
            color: #6c757d;
            margin-bottom: 2rem;
          }
          .form-label-login {
            font-weight: 600;
            color: #343a40;
            font-size: 0.9rem;
          }
          .form-control-login {
            border-radius: 8px;
            border: 1px solid #ced4da;
            padding: 0.75rem 1rem;
            /* Adjusted padding-left to make space for the icon */
            padding-left: 3rem; /* Increased from 2.5rem */
            font-size: 1rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
            width: 100%; /* Ensure input takes full width of its container */
          }
          .form-control-login:focus {
            border-color: ${primaryAccentColor};
            box-shadow: 0 0 0 0.2rem rgba(229, 39, 46, 0.2);
            background-color: #fff;
          }
          .input-group-login {
            position: relative;
            display: flex; /* Use flex to align icon and input */
            align-items: center; /* Vertically align items */
          }
          .input-group-login .input-icon {
            position: absolute;
            left: 16px; /* Adjusted left position */
            top: 50%;
            transform: translateY(-50%);
            color: #adb5bd;
            font-size: 1.1rem;
            z-index: 2; /* Ensure icon is above input field's content area */
          }
          .password-toggle-icon {
            position: absolute;
            right: 16px; /* Adjusted right position */
            top: 50%;
            transform: translateY(-50%);
            color: #adb5bd;
            cursor: pointer;
            font-size: 1.2rem;
            z-index: 2;
          }
          .login-btn-submit {
            background-image: ${gradientColor};
            color: white;
            border: none;
            padding: 0.8rem 1.5rem;
            border-radius: 50px;
            font-weight: 600;
            font-size: 1.05rem;
            transition: opacity 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
            width: 100%;
            margin-top: 1rem;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          }
          .login-btn-submit:hover {
            opacity: 0.85;
            transform: translateY(-2px);
            box-shadow: 0 6px 15px rgba(229, 39, 46, 0.25);
          }
          .login-btn-submit:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }
          .login-links {
            font-size: 0.85rem;
          }
          .login-links a {
            color: ${primaryAccentColor};
            text-decoration: none;
            font-weight: 500;
          }
          .login-links a:hover {
            text-decoration: underline;
          }
          .error-message {
            color: #dc3545;
            font-size: 0.8rem;
            margin-top: 0.25rem;
          }
         

          /* Responsive adjustments */
          @media (max-width: 768px) {
            .login-card {
              flex-direction: column;
            }
            .login-visual-section {
              min-height: 250px; /* Ensure some height on mobile */
              border-radius: 16px 16px 0 0; /* Round top corners */
            }
            .login-form-section {
              padding: 2rem 1.5rem; /* Adjust padding for smaller screens */
            }
            .login-title {
              font-size: 1.8rem;
            }
          }
        `}
      </style>
      <section className="login-page-container">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              {" "}
              {/* Column to contain the card */}
              <div className="login-card">
                <div className="login-form-section">
                  <h2 className="login-title">
                    <FiLogIn /> Welcome Back!
                  </h2>
                  <p className="login-subtitle">
                    Login to continue your Booze247 experience.
                  </p>
                  <form onSubmit={loginHandleSubmit} noValidate>
                    <div className="mb-3">
                      <label
                        htmlFor="email"
                        className="form-label form-label-login"
                      >
                        Email Address
                      </label>
                      <div className="input-group-login">
                        <input
                          type="email"
                          className={`form-control form-control-login ${
                            loginErrors.email && loginTouched.email
                              ? "is-invalid"
                              : ""
                          }`}
                          id="email"
                          name="email"
                          placeholder="you@example.com"
                          value={loginValues.email}
                          onBlur={loginHandleBlur}
                          onChange={loginHandleChange}
                        />
                      </div>
                      {loginErrors.email && loginTouched.email && (
                        <p className="error-message">{loginErrors.email}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="password"
                        className="form-label form-label-login"
                      >
                        Password
                      </label>
                      <div className="input-group-login">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`form-control form-control-login ${
                            loginErrors.password && loginTouched.password
                              ? "is-invalid"
                              : ""
                          }`}
                          id="password"
                          name="password"
                          placeholder="Enter your password"
                          value={loginValues.password}
                          onBlur={loginHandleBlur}
                          onChange={loginHandleChange}
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="password-toggle-icon"
                        >
                          {showPassword ? <FiEyeOff /> : <FiEye />}
                        </span>
                      </div>
                      {loginErrors.password && loginTouched.password && (
                        <p className="error-message">{loginErrors.password}</p>
                      )}
                    </div>

                    <div className="mb-3 form-check d-flex justify-content-between login-links">
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="rememberMe"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="rememberMe"
                        >
                          Remember me
                        </label>
                      </div>
                      <Link to="/forgot-password">Lost your password?</Link>
                    </div>

                    <button
                      type="submit"
                      className="btn login-btn-submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Logging in...
                        </>
                      ) : (
                        "Login"
                      )}
                    </button>
                  </form>

                  <div className="divider">OR</div>
                  <button
                    className="google-login-btn"
                    onClick={() => {
                      handleGoogleLogin();
                    }}
                  >
                    {" "}
                    <FcGoogle className="google-icon" /> Login with Google
                  </button>
                  <button
                    className="google-login-btn"
                    style={{
                      marginTop: "10px",
                    }}
                    onClick={() => {
                      handleFacebookLogin();
                    }}
                  >
                    {" "}
                    <FaFacebook style={{
                      color: "#4267B2",
                     
                      marginRight: "10px",
                    }}  className="google-icon" /> Login with Facebook
                  </button>
                  <div className="text-center mt-4 login-links">
                    <span>Don't have an account? </span>
                    <Link to="/register">Create One</Link>
                  </div>
                </div>
                <div className="login-visual-section d-none d-md-flex">
                  {" "}
                  {/* Hidden on screens smaller than md */}
                  <h2>Booze247</h2>
                  <p>
                    Your favourite drinks, delivered fast, anytime. Login to get
                    the party started!
                  </p>
                  {/* You can add a larger SVG icon here if desired */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
